export default __webpack_public_path__ + "static/Plain-Medium-ff87c1833bdb7dcc51915814163e011e.woff";